/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import clsx from "clsx";
import React from "react";
import {useTranslation} from "react-i18next";

interface BookingLoginReservationDetailButtonProps {
    className?: string;
    children: React.ReactNode | React.ReactNode[];
    isLoading?: boolean;
    disabled?: boolean;
}

const ButtonInnerIsLoading = () => {
    return (
        <svg className="animate-spin w-5 h-5 mr-1.5" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path
                className="opacity-75"
                d="M4 12a8 8 0 0 1 8-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 0 1 4 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                fill="currentColor"
            />
        </svg>
    );
};

const BookingLoginReservationDetailButtonInner = (props: BookingLoginReservationDetailButtonProps) => {
    const {t} = useTranslation();
    return (
        <div
            className={clsx(
                "BookingLoginReservationDetailButtonInner rounded-md px-2 py-0.5 border active:bg-opacity-80 focus:bg-opacity-80 hover:bg-opacity-90 text-white inline-flex w-auto items-center text-center justify-center text-sm leading-6 font-bold cursor-pointer",
                props?.className ? props.className : "border-blue-400 bg-blue-400",
                props?.disabled && "bg-gray-300 border-gray-300 !cursor-not-allowed"
            )}
        >
            {props.isLoading && <ButtonInnerIsLoading />}
            {props.children}
        </div>
    );
};

export default BookingLoginReservationDetailButtonInner;
